import { render, staticRenderFns } from "./OrderGlobalCard.vue?vue&type=template&id=0ab9d21c&scoped=true"
import script from "./OrderGlobalCard.vue?vue&type=script&lang=js"
export * from "./OrderGlobalCard.vue?vue&type=script&lang=js"
import style0 from "./OrderGlobalCard.vue?vue&type=style&index=0&id=0ab9d21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab9d21c",
  null
  
)

export default component.exports